module.exports = __webpack_public_path__ + "static/img/jj_banner.4cd5f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/jj_banner.png
// module id = tnIA
// module chunks = 1